export enum AppFeatures {
  CAN_EDIT_BLOGS = 'canEditBlogs',
  TINY_MCE_KEY = 'tinyMCEKey',
}

export interface AppFeaturesModel {
  [AppFeatures.CAN_EDIT_BLOGS]?: boolean;
  [AppFeatures.TINY_MCE_KEY]?: string;
}
